export const LOGOUT_TRACE_KEY = 'lastLogoutTrace';

/**
 * Records which code path ended the session.
 * Persisted in localStorage because most logout paths redirect immediately,
 * so the console entry is lost: read `lastLogoutTrace` after the fact to know
 * whether a session ended on inactivity, an API rejection or a user action.
 */
export const traceLogout = (reason, context = {}) => {
  const trace = {
    reason,
    at: new Date().toISOString(),
    path: window.location.pathname,
    isOnline: navigator.onLine,
    businessId: localStorage.getItem('businessId') || null,
    ...context,
  };

  console.warn('[logout]', trace);

  try {
    localStorage.setItem(LOGOUT_TRACE_KEY, JSON.stringify(trace));
  } catch (_) {
    // Storage full or unavailable: the console entry is the fallback.
  }
};
